export const FORCE_SWITCH_LEGAL_ENTITY_PARAM = "force-switch-legal-entity";
export const CURRENT_LEGAL_ENTITY_LOCAL_STORAGE_KEY = "collaborator-current-legal-entity-uuid";
export const CURRENT_LEGAL_MODE_LOCAL_STORAGE_KEY = "collaborator-current-legal-mode";
